import {
  defaultRescuePlacementNavigationState,
  rescuePlacementPath,
  RescuePlacementNavigationState,
} from '../../rescuePlacementUtils';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import styles from './GoBackLink.module.scss';

export default function GoBackLink({ state }: { state?: RescuePlacementNavigationState }) {
  const { t } = useTranslation();
  return (
    <Link
      className={styles.main}
      to={{
        pathname: rescuePlacementPath,
        state: state || defaultRescuePlacementNavigationState,
      }}
    >
      {'<'} {t('go_back')}
    </Link>
  );
}
